import DOMPurify from 'dompurify'

/**
 * Sanitize HTML produced by marked or other renderers before v-html.
 */
export function sanitizeHtml(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true }
  })
}

/** Rich CMS HTML: allow iframe embeds from http(s) only. */
export function sanitizeRichHtml(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'height', 'width', 'class', 'style']
  })
}
